// Strip control/bidi chars (Trojan-Source) + backticks (prompt fences) + collapse whitespace from untrusted sender text before an AI prompt.
export function sanitizeField(s: string): string {
  return s.replace(/[\s`\p{Cc}\p{Cf}]+/gu, " ").trim();
}
